const awsConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: "3uu8qcb0nciohi6mqh1cqca4ju",
      region: "ap-southeast-1",
      userPoolId: "ap-southeast-1_1WAjSGN0q",
      loginWith: {
        // Optional
        oauth: {
          domain:
            "partner-portal-preprod.auth.ap-southeast-1.amazoncognito.com",
          scopes: ["phone openid email profile"],
          redirectSignIn: [`${window.location.origin}`],
          redirectSignOut: [`${window.location.origin}`],
          responseType: "code",
        },
        username: "true",
        email: "false", // Optional
        phone: "false", // Optional
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: "https://api-partner-portal-preprod.generali.co.th/graphql",
      region: "ap-southeast-1",
      // Set the default auth mode to "apiKey" and provide the API key value
      defaultAuthMode: "userPool",
    },
  },
};

const integrationConfig = {
  genEzeLogin: "https://saletool-preprod.generali.co.th/logincognito",
};

const logoutUri = `https://${awsConfig.Auth.Cognito.loginWith.oauth.domain}/logout?client_id=${awsConfig.Auth.Cognito.userPoolClientId}&response_type=${awsConfig.Auth.Cognito.loginWith.oauth.responseType}&redirect_uri=${encodeURIComponent(window.location.origin)}`;

const config = { awsConfig, integrationConfig, logoutUri };

export default config;
